var exports = {
  "kL": "AvatarWithPresence.module__container___cGxCTH",
  "_V": "AvatarWithPresence.module__containerSpeaking___cGxCTH",
  "V5": "AvatarWithPresence.module__voiceIndicatorIcon___cGxCTH",
};

module.exports = exports;
